const UTXOGatewayScript = (opcode, script, gPubKeyHash, gHash) => new script()
    .add(gHash)
    .add(opcode.OP_DROP)
    .add(opcode.OP_DUP)
    .add(opcode.OP_HASH160)
    .add(gPubKeyHash)
    .add(opcode.OP_EQUALVERIFY)
    .add(opcode.OP_CHECKSIG)
    .toScriptHashOut();
export const createAddress = (networks, opcode, script) => (isTestnet, gPubKeyHash, gHash) => UTXOGatewayScript(opcode, script, gPubKeyHash, gHash)
    .toAddress(isTestnet ? networks.testnet : networks.mainnet)
    .toString();
export const pubKeyScript = (_networks, opcode, script) => (_isTestnet, gPubKeyHash, gHash) => UTXOGatewayScript(opcode, script, gPubKeyHash, gHash).toBuffer();
//# sourceMappingURL=v1.js.map